import { NOT_ASSIGNED } from 'constants/constants';
import React from 'react';
import { ScenarioItemModel } from 'types/types';

import VersionHistorySummaryGrid, { SummaryGridRow } from '../VersionHistorySummaryGrid';
import { EpdVersionHistoryData } from '../utils/EpdVersionHistoryDataContext';

const VersionHistoryScenarioGrid: React.FC<{ scenario: ScenarioItemModel }> = ({ scenario }) => {
  const rows = getScenarioGridRows(undefined, false, scenario);

  return <VersionHistorySummaryGrid rows={rows} />;
};

export default VersionHistoryScenarioGrid;

export function getScenarioGridRows(data?: EpdVersionHistoryData, isPcrV2?: boolean, scenario?: ScenarioItemModel) {
  if (!scenario) {
    return [];
  }

  const possibleRows: (SummaryGridRow | false)[] = scenario.isDefaultScenario
    ? [
        {
          ord: 1,
          name: 'Name of the default scenario',
          value: scenario.name ?? NOT_ASSIGNED,
        },
        {
          ord: 2,
          name: 'Description of the default scenario',
          value: scenario.description ?? NOT_ASSIGNED,
        },
      ]
    : [
        {
          ord: 3,
          name: 'Name of the additional scenario',
          value: scenario.name ?? NOT_ASSIGNED,
        },
        {
          ord: 4,
          name: 'Description of the additional scenario',
          value: scenario.description ?? NOT_ASSIGNED,
        },
      ];

  const rows = possibleRows.filter((r) => r) as SummaryGridRow[];

  return rows;
}
